.platformSection {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	padding-left: 0.5rem;
	box-sizing: border-box;
	height: 100%;
}

.proctorSettingsGridPlatforms {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: space-evenly;
	gap: 1rem;
	width: 100%;
}

.platformButtonWrapper {
	display: grid;
	grid-template-columns: 40px minmax(0, 1fr);
	gap: 0.75rem;
	padding: 1rem;
	box-sizing: border-box;

	.contentWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
		width: 100%;
		align-items: flex-start;
		justify-content: flex-start;
		grid-column: 2;
	}

	.platformButton {
		width: 100%;
		display: contents;
	}
}

.platformInfoWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
	align-items: flex-start;
}

.platformColWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.375rem;
	align-items: flex-start;

	& .title {
		color: #212121;
		font-weight: 600;
		font-size: 1rem;
		line-height: 1.4;
		letter-spacing: -0.31px;
	}

	& .description {
		color: #5e5e5e;
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.6;
		text-align: left;
	}

	& .subtitle {
		color: #737373;
		font-size: 0.9375rem;
		font-weight: 500;
	}
}

.platformTitleCheckmarkWrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.badgeRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.platformBadge:global(.MuiChip-root) {
	min-height: fit-content;
	width: fit-content;
	border-radius: 6px;
	padding: 0.25rem 0.625rem;
	box-sizing: border-box;
	min-width: unset;

	& span {
		font-weight: 500;
		font-size: 0.8375rem;
		line-height: 1.6;
	}
}

.platformBadgeCompact {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	width: 28px;
	height: 20px;
	flex-shrink: 0;
}

.platformDivider {
	width: 100%;
}

.browserPlatform {
	grid-template-columns: 36px minmax(0, 1fr);
	letter-spacing: normal;

	&:has(button[aria-pressed="true"]) {
		border-color: #b7a6d1;
		background: #ffffff;
	}

	.platformIcon {
		border-radius: 8px;
	}

	.platformTitleCheckmarkWrapper .title,
	.description,
	.subtitle {
		letter-spacing: normal;
	}

	.platformBadge:global(.MuiChip-root) span {
		font-size: 13px;
		letter-spacing: normal;
	}

	.description {
		font-size: 14px;
		line-height: 22px;
	}

	.subtitle {
		font-size: 14px;
		line-height: 20px;
	}
}

.protoredMethodTitleSub:global(.MuiTypography-root) {
	color: #101828;
	font-size: 0.9375rem;
	font-weight: 600;
	line-height: 1.6;
	letter-spacing: -0.15px;
	text-align: left;
	vertical-align: middle;
}

.protoredMethodDescriptionSub:global(.MuiTypography-root) {
	font-size: 0.875rem;
	color: #4a5565;
	font-weight: 400;
	line-height: 1.6;
	letter-spacing: 0em;
	text-align: left;
}

.checkboxes {
	display: flex;
	align-items: start;
	flex-wrap: wrap;
	gap: 0.5rem;
}

.checkboxInfoWrapper {
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	&:hover {
		cursor: pointer;
	}
}

.labeledCheckboxContainer {
	min-width: min(100%, 300px);
	display: flex;
	flex: 1;
	gap: 0.5rem;
	align-items: flex-start;
}

.checkboxHeaderWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
}

@media (max-width: 768px) {
	.platformSection {
		gap: 0.5rem;
		padding-left: unset;
		padding: 0.5rem;
	}

	.platformButtonWrapper {
		height: unset;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0.5rem;

		.platformButton {
			flex-direction: column-reverse;
			align-items: center;
		}
	}

	.badgeRow {
		display: grid;
		grid-template-columns: 1fr 1fr;
		width: 100%;
	}

	.checkboxes {
		flex-direction: column;
	}

	.checkboxHeaderWrapper {
		align-items: flex-start;
	}
}
